import React, { useCallback, useEffect, useState } from "react";
import {
  fetchDataAlleGebruikers,
  handleSignUp,
  updateToegang,
} from "../../apiCalls/usersApi";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDoorClosed, faDoorOpen } from "@fortawesome/free-solid-svg-icons";
import SelectGebruikers from "../../Componenten/SelectGebruikers";
import SendEmailButton2 from "../../Componenten/Email/SendEmailButton2";

const desiredColumns = [
  "toegang",
  "inscription",
  "username",
  "first_name",
  "last_name",
  "phone",
  "email",
  "password",
  "id",
  "role",
  "notes",
];

const btnGhost =
  "rounded-lg border border-[#2a3942] bg-[#202c33] px-3 py-1.5 text-left text-xs font-medium text-[#e9edef] transition-colors hover:border-[#00a884]/60 hover:bg-[#2a3942] disabled:cursor-not-allowed disabled:opacity-40";

const btnRegistered =
  "cursor-default rounded-lg border border-[#00a884]/35 bg-[#005c4b]/25 px-3 py-1.5 text-xs font-medium text-[#e9edef]";

const Gebruikers = () => {
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(50);
  const [role, setRole] = useState(999);
  const [type, setType] = useState("all");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [data, setData] = useState([]);
  const [activeTab, setActiveTab] = useState("Alle gebruikers");

  useEffect(() => {
    fetchDataAlleGebruikers(
      page,
      pageSize,
      setLoading,
      setError,
      setData,
      desiredColumns,
      role,
      type
    );
  }, [page, pageSize, role, type]);

  const signUp = useCallback(
    async (item) => {
      handleSignUp(
        item,
        page,
        pageSize,
        setLoading,
        setError,
        setData,
        desiredColumns,
        role,
        type
      );
    },
    [page, pageSize, role, type]
  );

  const toegangPlatorm = useCallback(
    async (item) => {
      updateToegang(
        item,
        page,
        pageSize,
        setLoading,
        setError,
        setData,
        desiredColumns,
        role,
        type
      );
    },
    [page, pageSize, role, type]
  );

  return (
    <div className="flex min-h-0 flex-1 flex-col bg-[#0b141a] text-[#e9edef]">
      <SelectGebruikers
        setData={setData}
        data={data}
        setPage={setPage}
        setPageSize={setPageSize}
        setLoading={setLoading}
        setError={setError}
        role={role}
        type={type}
        desiredColumns={desiredColumns}
        setType={setType}
        setRole={setRole}
        page={page}
        pageSize={pageSize}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
      />

      <div className="flex flex-1 flex-col px-3 pb-8 pt-2 sm:px-4">
        {loading ? (
          <p className="py-6 text-center text-sm text-[#8696a0]">Laden…</p>
        ) : null}
        {error ? (
          <p className="rounded-lg border border-red-800/50 bg-red-950/30 px-3 py-2 text-sm text-red-200" role="alert">
            {error}
          </p>
        ) : null}

        <div className="mt-2 overflow-x-auto rounded-xl border border-[#2a3942] shadow-lg shadow-black/20">
          <table className="min-w-[920px] w-full border-collapse text-left text-sm">
            <thead>
              <tr className="border-b border-[#2a3942] bg-[#202c33]">
                {data.length > 0 &&
                  Object.keys(data[0]).map((key, index) =>
                    index < 8 ? (
                      <th
                        key={key}
                        scope="col"
                        className={`whitespace-nowrap px-4 py-3 text-xs font-semibold uppercase tracking-wide text-[#8696a0] ${
                          index === 0 ? "w-14" : "min-w-[10rem]"
                        }`}
                      >
                        {key}
                      </th>
                    ) : null
                  )}
              </tr>
            </thead>
            <tbody className="divide-y divide-[#222d34] bg-[#111b21]">
              {data.length > 0 &&
                data.map((row, rowIndex) => (
                  <tr
                    key={rowIndex}
                    className="transition-colors hover:bg-[#1c2723]"
                  >
                    {Object.values(row).map((value, i) =>
                      i < 8 ? (
                        i === 0 ? (
                          <td
                            key={`${rowIndex}-0`}
                            className="w-14 cursor-pointer px-4 py-3 align-middle"
                            onClick={() => toegangPlatorm(row)}
                            title={
                              value > 0
                                ? "Heeft toegang tot de portaal"
                                : "Geen toegang tot de portaal"
                            }
                          >
                            {value > 0 ? (
                              <FontAwesomeIcon
                                className="h-5 w-5 text-[#00a884]"
                                icon={faDoorOpen}
                              />
                            ) : (
                              <FontAwesomeIcon
                                className="h-5 w-5 text-[#54656f]"
                                icon={faDoorClosed}
                              />
                            )}
                          </td>
                        ) : (
                          <td
                            key={`${rowIndex}-${i}`}
                            className="max-w-xs px-4 py-3 align-middle text-[#e9edef]"
                          >
                            {i === 1 ? (
                              <button
                                type="button"
                                className={value === 1 ? btnRegistered : btnGhost}
                                disabled={value === 1}
                                onClick={() => signUp(row)}
                              >
                                {value === 0 ? "Inschrijven" : "ingeschreven"}
                              </button>
                            ) : i === 7 ? (
                              row.email ||
                              (row?.username?.includes("@") && row.role !== 999) ? (
                                <SendEmailButton2
                                  email={{
                                    receiver: row.email || row.username,
                                    user: row.username,
                                    first_name: row.first_name,
                                    last_name: row.last_name,
                                    name: `${row?.first_name} ${row?.last_name}`,
                                    password: row.password,
                                    from_name: row.first_name,
                                  }}
                                />
                              ) : (
                                <span className="font-mono text-xs text-[#8696a0]">
                                  {row.password}
                                </span>
                              )
                            ) : (
                              <span className="block truncate" title={value != null ? String(value) : ""}>
                                {value}
                              </span>
                            )}
                          </td>
                        )
                      ) : null
                    )}
                  </tr>
                ))}
            </tbody>
          </table>
        </div>

        {!loading && data.length === 0 ? (
          <p className="py-10 text-center text-sm text-[#8696a0]">Geen gebruikers gevonden.</p>
        ) : null}
      </div>
    </div>
  );
};

export default Gebruikers;
